import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconTotalNetPay: React.FC<Props> = ({
  width = 18,
  height = 16,
  // color = "#FFFFFF",
  // disabled = false,
}: Props) => (
  <svg width={width} 
        height={height} 
        viewBox="0 0 18 16" fill="none" 
        xmlns="http://www.w3.org/2000/svg">

        <path d="M17.125 3.83334V8C17.125 8.345 16.845 8.625 16.5 8.625C16.155 8.625 15.875 8.345 15.875 8V3.83334C15.875 2.51917 15.3142 1.95834 14 1.95834H4C2.68583 1.95834 2.125 2.51917 2.125 3.83334V10.5C2.125 11.8142 2.68583 12.375 4 12.375H10.6667C11.0117 12.375 11.2917 12.655 11.2917 13C11.2917 13.345 11.0117 13.625 10.6667 13.625H4C1.985 13.625 0.875 12.515 0.875 10.5V3.83334C0.875 1.81834 1.985 0.708336 4 0.708336H14C16.015 0.708336 17.125 1.81834 17.125 3.83334ZM3.16667 7.16667C3.16667 7.62667 3.54 8 4 8C4.46 8 4.83333 7.62667 4.83333 7.16667C4.83333 6.70667 4.46 6.33334 4 6.33334C3.54 6.33334 3.16667 6.70667 3.16667 7.16667ZM9 4.04167C10.7233 4.04167 12.125 5.44334 12.125 7.16667C12.125 8.89 10.7233 10.2917 9 10.2917C7.27667 10.2917 5.875 8.89 5.875 7.16667C5.875 5.44334 7.27667 4.04167 9 4.04167ZM9 5.29167C7.96583 5.29167 7.125 6.1325 7.125 7.16667C7.125 8.20084 7.96583 9.04167 9 9.04167C10.0342 9.04167 10.875 8.20084 10.875 7.16667C10.875 6.1325 10.0342 5.29167 9 5.29167ZM15.2758 10.0583C15.2183 10.0008 15.1492 9.95499 15.0725 9.92332C14.92 9.85999 14.7475 9.85999 14.595 9.92332C14.5183 9.95499 14.4491 10.0008 14.3916 10.0583L12.725 11.725C12.4808 11.9691 12.4808 12.365 12.725 12.6092C12.9691 12.8533 13.365 12.8533 13.6092 12.6092L14.2091 12.0091V14.6667C14.2091 15.0117 14.4891 15.2917 14.8341 15.2917C15.1791 15.2917 15.4591 15.0117 15.4591 14.6667V12.0091L16.0592 12.6092C16.1808 12.7308 16.3408 12.7925 16.5008 12.7925C16.6608 12.7925 16.8208 12.7317 16.9425 12.6092C17.1867 12.365 17.1867 11.9691 16.9425 11.725L15.2758 10.0583Z" fill="#3E454D"/>
  </svg>
  
);

export default IconTotalNetPay;
